import { useContext, createContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/auth";
import { useUserStore } from "../store/user";
import { useNotification } from "./NotificationContext";
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const { setIsAuthenticated, setAuthData, handleLogout, accessToken, isAuthenticated } = useAuthStore();
  const { setUser, resetUser } = useUserStore();
  const navigate = useNavigate();
  const { addNotification } = useNotification();

  const loginAction = () => {
    try {
      const popupWindow = window.open(
        `${process.env.REACT_APP_API_URL}/auth/steam`,
        "_blank",
        "width=800, height=600",
      );
      if (window.focus) popupWindow.focus();
    } catch (err) {
      console.error(err);
    }
  };

  window.addEventListener("message", event => {
    if (event.origin !== process.env.REACT_APP_API_URL) return;

    const { token, user, ok } = event.data;
    if (ok) {
      const userData = JSON.parse(user);
      setAuthData({ accessToken: token, uid: userData.id });
      setIsAuthenticated(true);
      setUser({ accessToken: token, ...userData });
      localStorage.setItem("token", token);

      if (!isAuthenticated) {
        addNotification({
          message: 'Authentication',
          description: 'You successfully logged in with Steam',
          duration: 4,
          type: 'success',
        });
      }
    }
  });

  const logOut = () => {
    resetUser();
    handleLogout();
    localStorage.removeItem("token");

    addNotification({
      message: 'Authentication',
      description: 'You have been logged out',
      duration: 4,
      type: 'error',
    });

    navigate("/");
  };

  return (
    <AuthContext.Provider value={{ token: accessToken, loginAction, logOut }}>
      {children}
    </AuthContext.Provider>
  );

};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};